module.exports = __webpack_public_path__ + "img/not-found.35de5e4b.svg";